import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Spinner from '@fec/frontend/elements/loading/spinner/Spinner';
import Button from '@fec/frontend/elements/buttons/button/button';
import LivetickerUpdater from '@fec/frontend/modules/liveticker/LivetickerUpdater/LivetickerUpdater.jsx';

import './Liveticker.scss';

const Liveticker = forwardRef(function Liveticker(
  {
    status,
    statusText,
    showSpinner = false,
    onShowCurrent = () => {},
    onShowEarlier = () => {},
    laterMessages = 0,
    earlierMessages = 0,
    children,
  },
  ref,
) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('liveticker', {
        'liveticker--live': status === 'live',
      })}
      ref={ref}>
      <p className="liveticker__info">{statusText}</p>

      {/* Button to show the newest messages */}
      <LivetickerUpdater
        nrOfNewMessages={laterMessages}
        onClick={onShowCurrent}
      />

      {showSpinner && (
        <div className="liveticker__spinner-container">
          <Spinner />
        </div>
      )}

      <ul
        className={classNames('liveticker__list', {
          'liveticker__list--closed': status === 'closed',
          'liveticker__list--live': status === 'live',
          'liveticker__list--scheduled': status === 'scheduled',
        })}>
        {children}
      </ul>

      {earlierMessages > 0 && (
        <Button
          styleModifier={classNames(
            'button--white',
            'button--mixed-case',
            'button--link-text-color',
            'button--no-spacing',
            'button--full-width',
          )}
          svgIcon="svg-icon--arrow-down-red"
          buttonText={t('Mehr anzeigen')}
          onClick={onShowEarlier}
        />
      )}
    </div>
  );
});

export default Liveticker;
